<template>
  <section v-loading="loading" class="section-block">
    <SectionTitle title="GA 串接設定" @edit="showEditModal = true" />

    <BaseElForm label-position="left" label-width="250px">
      <BaseElFormItem label="Google 代碼 ID">
        {{ displayData.googleAnalyticsMeasurementId || '-' }}
      </BaseElFormItem>
    </BaseElForm>

    <div class="mt-6">
      <div class="font-bold mb-2">現有通用事件</div>
      <el-table :data="commonEvents" border stripe size="small">
        <el-table-column prop="code" label="事件代碼" width="350" />
        <el-table-column prop="description" label="事件說明" />
      </el-table>
    </div>

    <MemberCenterGASettingEditDialog
      v-if="showEditModal"
      :configData="configData"
      @close="showEditModal = false"
      @refresh="handleRefresh"
    />
  </section>
</template>

<script>
import { defineComponent, ref, computed, onMounted } from 'vue'
import SectionTitle from '@/components/Title/SectionTitle.vue'
import MemberCenterGASettingEditDialog from './MemberCenterGASettingEditDialog.vue'
import { GetClientPageConfig } from '@/api/member/memberCenter'
import { useShop } from '@/use/shop'

export default defineComponent({
  name: 'MemberCenterGASetting',
  components: {
    SectionTitle,
    MemberCenterGASettingEditDialog,
  },
  emits: ['refresh'],
  setup (props, { emit }) {
    const { shopId } = useShop()
    const loading = ref(false)
    const showEditModal = ref(false)
    const configData = ref({})

    const displayData = computed(() => {
      return {
        googleAnalyticsMeasurementId: configData.value.googleAnalyticsMeasurementId,
      }
    })

    const commonEvents = [
      { code: 'appointment_checkout_confirm_appointment', description: '使用者按下確認預約按鈕' },
      { code: 'menu_select_service', description: '於預約中心選單選擇主服務' },
      { code: 'menu_select_sub_service', description: '於預約中心選單選擇子服務' },
      { code: 'appointment-homepage-confirm', description: '於預約中心選單的確認預約須知彈窗按下確定按鈕' },
    ]

    const getClientPageConfig = async () => {
      loading.value = true
      const [res, err] = await GetClientPageConfig({ shopId: shopId.value })
      loading.value = false
      if (err) {
        window.$message.error(err)
        return
      }
      configData.value = res
    }

    const handleRefresh = async () => {
      await getClientPageConfig()
      emit('refresh')
    }

    onMounted(() => {
      getClientPageConfig()
    })

    return {
      loading,
      showEditModal,
      configData,
      displayData,
      handleRefresh,
      commonEvents,
    }
  },
})
</script>

<style lang="postcss" scoped>
</style>
